export default function(errors, key) {
    return () => {
        if (errors && errors[key]) {
            return false;
        }

        return true;
    };
}
